import { useMemo } from 'react'

import { Scope } from '@unform/core'

import Panel from '~/components/Panel'
import { Checkbox, FormGroup } from '~/components/unform'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import { useCampaignForm } from '../../hooks/useCampaignForm'
import BudgetType from '../BudgetTypeScope'
import CostTypeScope from '../CostTypeScope'
import Placements from '../Placements'

const AdvancedSettings: React.FC<AdvancedSettingsFieldsetProps> = ({
  targeting,
  showDeliveryPace = true
}) => {
  const { t } = useAPPTranslation()
  const {
    campaignPermissions,
    costType,
    selectedType,
    allowAgeRestrictedCampaign
  } = useCampaignForm()

  const isBanner = useMemo(() => selectedType === 'banner', [selectedType])

  const allowCostType = useMemo(
    () => isBanner && !!campaignPermissions?.allow_daily_cost_campaign,
    [campaignPermissions?.allow_daily_cost_campaign, isBanner]
  )
  const allowPlacements = useMemo(
    () => isBanner && !!campaignPermissions?.allow_placement_campaign,
    [campaignPermissions?.allow_placement_campaign, isBanner]
  )
  const allowBudgetType = useMemo(
    () => showDeliveryPace && costType === 'cpmcpc',
    [costType, showDeliveryPace]
  )

  return (
    <>
      <hr />

      <Panel
        title={t('rm:AdvancedSettings.title')}
        isCollapsible
        initialCollapsibleState={false}
      >
        {allowCostType && (
          <>
            <CostTypeScope />
            <hr />
          </>
        )}

        {allowPlacements && (
          <>
            <Placements
              targeting={targeting}
              adType={selectedType as AdTypeWithTargeting}
            />

            <hr />
          </>
        )}

        {allowAgeRestrictedCampaign && (
          <Scope path="settings">
            <FormGroup>
              <Checkbox
                name="age_restricted"
                label={t('rm:campaign.settings.ageRestricted.label')}
              />
            </FormGroup>
          </Scope>
        )}

        {(allowPlacements || allowBudgetType) && <hr />}

        {allowBudgetType && <BudgetType />}
      </Panel>
    </>
  )
}

export default AdvancedSettings
